import React, { useState } from "react";
import { useAuth } from "../../components/context/Auth";
import styles from "./Voucher.module.css";
import Production from "./Production";
import ProductionAndSales from "./ProductionAndSales";

const Voucher = ({
  otpActoken,
  setOtpAcToken,
  managerId,
  deviceId,
  iPInfo,
  browserName,
  operatinySystem,
  show,
}) => {
  const { mode } = useAuth();
  const [activeTab, setActiveTab] = useState("sales");

  const TABS = [
    {
      id: "sales",
      label: "Sales",
    },
    {
      id: "collection",
      label: "Collection",
    },
    {
      id: "purchase",
      label: "Purchase",
    },
    {
      id: "adjustment",
      label: "Adjustment",
    },
    {
      id: "production",
      label: "Production",
    },
    {
      id: "productionAndSales",
      label: "Production & Sales",
    },
  ];

  return (
    <div className={`${styles.root} ${mode ? styles.dark : styles.light}`}>
      {/* TOP BAR */}
      <div className={styles.header}>
        {/* <div>Voucher</div> */}

        {/* TABS */}
        <div className={styles.mainTab}>
          <div className={styles.tabBar}>
            {TABS.map((tab) => (
              <button
                key={tab.id}
                className={`${styles.tabBtn} ${
                  activeTab === tab.id ? styles.tabBtnActive : ""
                }`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {activeTab === "sales" && <p>{activeTab}</p>}
        {activeTab === "collection" && <p>{activeTab}</p>}
        {activeTab === "purchase" && <p>{activeTab}</p>}
        {activeTab === "adjustment" && <p>{activeTab}</p>}
        {activeTab === "production" && (
          <Production otpActoken={otpActoken} setOtpAcToken={setOtpAcToken} />
        )}
        {activeTab === "productionAndSales" && (
          <ProductionAndSales
            otpActoken={otpActoken}
            setOtpAcToken={setOtpAcToken}
            managerId={managerId}
            deviceId={deviceId}
            iPInfo={iPInfo}
            browserName={browserName}
            operatinySystem={operatinySystem}
            show={show}
          />
        )}
      </div>
    </div>
  );
};

export default Voucher;
